import MessagesRepository from "@/repositories/messagesRepository";

const repositories: any = {
	messages: MessagesRepository,
};

export const RepositoryFactory: any = {
	get: (name: any) => repositories[name],
};
